import PropTypes from 'prop-types';
import { useFeatureFlag } from 'entities/helpers/use-feature-flag';
import NavigationExpandableItem from 'apps/layout/components/navigation-expandable-item';
import NavigationNestedItem from 'apps/layout/components/navigation-nested-item';
import NewBadge from 'components/elements/new-badge';

/**
 * Assets navigation section with Email Templates sub-item.
 * New nav section for Cadences 2.0.
 */
const NavigationAssetsLink = ({ active_path = '' }) => {
  const { flagEnabled: signalEnabled, loaded: signalLoaded } = useFeatureFlag('signal');
  const { flagEnabled, loaded } = useFeatureFlag('cadenceV2Internal');

  if (!loaded || !signalLoaded) return null;
  if (!signalEnabled || !flagEnabled) return null;

  const emailTemplatesRegex = /^\/email-templates.*/;

  const isEmailTemplatesActive = !!active_path.match(emailTemplatesRegex);
  const isParentActive = isEmailTemplatesActive;

  return (
    <NavigationExpandableItem
      icon="email-template"
      iconKit="gt2"
      label="Assets"
      isActive={isParentActive}
      defaultExpanded={isParentActive}
      badge={<NewBadge />}
    >
      <NavigationNestedItem
        label="Email Templates"
        path="/email-templates"
        isActive={isEmailTemplatesActive}
        trackingType="email_templates"
      />
      <NavigationNestedItem
        label="SMS Templates"
        isActive={false}
        onClick={() => {}}
        badge={<NewBadge label="COMING SOON" className="new-badge--coming-soon" />}
      />
    </NavigationExpandableItem>
  );
};

NavigationAssetsLink.propTypes = {
  active_path: PropTypes.string,
};

export default NavigationAssetsLink;
